import { CalculatorForm } from "../../components";

export function CalculatorPage() {
  return <CalculatorForm />;
}
